import template from './checks-filter.html';
import ChecksFilterController from './checks-filter.controller';
import './checks-filter.styl';

let checksFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: ChecksFilterController,
  controllerAs: 'vm'
};

export default checksFilterComponent;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/checks-filter/checks-filter.component.js
 **/